import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import StripeSetupForm from '../../../../components/StripeSetupForm'

export default function SponsorPledgeStripeModal({
  show,
  onHide,
  onPaymentSuccess,
  submitting,
}) {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      onHide={() => {
        if (!submitting) onHide()
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>
          {t('sponsorPledgeFlow.step5.paymentModalTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ position: 'relative' }}>
        {submitting ? (
          <div
            className="d-flex flex-column align-items-center justify-content-center py-5 gap-2"
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.85)',
              zIndex: 2,
            }}
          >
            <Spinner animation="border" />
            <span className="text-muted small">
              {t('sponsorPledgeFlow.step5.submittingPledge')}
            </span>
          </div>
        ) : null}
        <p className="text-muted small mb-3">
          {t('sponsorPledgeFlow.step5.paymentModalIntro')}
        </p>
        {show ? (
          <StripeSetupForm
            onSuccess={onPaymentSuccess}
            onCancel={submitting ? undefined : onHide}
          />
        ) : null}
      </Modal.Body>
    </Modal>
  )
}
